import { createContext } from 'react'
import { Box, Skeleton, VStack, HStack, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'

export const LoadingCtx = createContext({loading: false})

export const PageSkeleton = () => (
  <Box maxW="1200px" mx="auto" p={8}>
    <VStack spacing={6} align="stretch">
      <Skeleton h="2em" w="300px" mx="auto" />
      <Skeleton h="1.2em" w="400px" mx="auto" />
      <HStack justify="center" spacing={4}>
        {Array.from({length: 5}, (_, i) => <Skeleton key={i} h="40px" w="80px" borderRadius="md" />)}
      </HStack>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th w="50px">#</Th>
            <Th>Entry</Th>
            <Th isNumeric w="100px">Amount</Th>
            <Th w="80px"></Th>
          </Tr>
        </Thead>
        <Tbody>
          {Array.from({length: 5}, (_, idx) => (
            <Tr key={idx}>
              <Td>{idx + 1}</Td>
              <Td><Skeleton h="1.2em" w="120px" /></Td>
              <Td isNumeric><Skeleton h="1.2em" w="60px" ml="auto" /></Td>
              <Td><Skeleton h="1.2em" w="40px" /></Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </VStack>
  </Box>
)
